import React, { useState } from "react";
import profileImage from "../assets/img/avatars/profileImage.jpg";
import { toast } from "react-toastify";
import ImageModal from "../components/imageModel/imageMode.jsx";
import UserInfo from "../components/UserInfo.jsx";
import { handleCommercialRegisterRequest } from "actions/actions";

const BASE_URL = process.env.REACT_APP_ENDPOINT;

const statusLabels = {
  accepted: "مقبولة",
  pending: "قيد الانتظار",
  rejected: "مرفوضة",
};

const StatusBadge = ({ status }) => (
  <span
    className={`rounded-full px-2 py-1 text-xs ${
      status === "accepted"
        ? "bg-green-500 text-white"
        : status === "pending"
        ? "bg-yellow-500 text-white"
        : "bg-red-500 text-white"
    }`}
  >
    {statusLabels[status] || status || "-"}
  </span>
);

const CommercialRegisterChangeRequestsColumn = (refetch, requestType) => {
  const showSupplierProfileFile = requestType === "supplierProfilePdf";

  return [
    {
      Header: "تحديد",
      id: "checkbox",
    },
    {
      Header: "المستخدم",
      accessor: "user.name",
      Cell: ({ row }) => {
        const [isModalOpen, setIsModalOpen] = useState(false);
        const src = row.original.user?.photo
          ? `${BASE_URL}/${row.original.user.photo}`
          : profileImage;

        return (
          <div className="flex min-w-[140px] items-center gap-3">
            <img
              src={src}
              alt="صورة المستخدم"
              className="h-10 w-10 cursor-pointer rounded-full border border-gray-200"
              crossOrigin="anonymous"
              onClick={() => setIsModalOpen(true)}
            />
            {isModalOpen && (
              <ImageModal src={src} onClose={() => setIsModalOpen(false)} />
            )}
            <span className="font-medium">
              {row.original.user?.name || "—"}
            </span>
          </div>
        );
      },
    },
    {
      Header: "الهاتف",
      Cell: ({ row }) => (
        <a
          className="hover:underline"
          href={`tel:${row.original.user?.phoneNumber}`}
        >
          {row.original.user?.phoneNumber || "—"}
        </a>
      ),
    },
    {
      Header: "نوع المستخدم",
      Cell: ({ row }) => {
        const role = row.original.user?.role;
        if (role === "supplier") return "مورد";
        if (role === "contractor") return "مقاول";
        return "—";
      },
    },
    {
      Header: "نوع الطلب",
      accessor: "requestType",
      Cell: ({ row }) =>
        row.original.requestType === "supplierProfilePdf"
          ? "ملف المورد التعريفي"
          : "السجل التجاري",
    },
    !showSupplierProfileFile && {
      Header: "السجل التجاري",
      accessor: "commercialRegister",
      Cell: ({ row }) => row.original.commercialRegister || "-",
    },
    !showSupplierProfileFile && {
      Header: "صورة السجل",
      accessor: "commercialRegisterPhoto",
      Cell: ({ row }) => {
        const [open, setOpen] = useState(false);
        const photo = row.original.commercialRegisterPhoto;
        if (!photo) return <span>-</span>;

        return (
          <>
            <img
              src={`${BASE_URL}/${photo}`}
              alt="صورة السجل التجاري"
              className="h-10 w-10 cursor-pointer rounded border border-gray-200"
              crossOrigin="anonymous"
              onClick={() => setOpen(true)}
            />
            {open && (
              <ImageModal
                src={`${BASE_URL}/${photo}`}
                onClose={() => setOpen(false)}
              />
            )}
          </>
        );
      },
    },
    showSupplierProfileFile && {
      Header: "ملف المورد التعريفي",
      accessor: "profilePdf",
      Cell: ({ row }) => {
        const pdf = row.original.profilePdf;
        if (!pdf) return <span>-</span>;

        return (
          <a
            href={`${BASE_URL}/${pdf}`}
            target="_blank"
            rel="noreferrer"
            className="text-blue-500 hover:underline"
          >
            عرض الملف
          </a>
        );
      },
    },
    !showSupplierProfileFile && {
      Header: "تاريخ الانتهاء",
      accessor: "commercialRegisterExpirationDate",
      Cell: ({ row }) => {
        if (!row.original.commercialRegisterExpirationDate)
          return <span>-</span>;
        const date = new Date(
          row.original.commercialRegisterExpirationDate
        ).toLocaleDateString("ar-EG");
        return <span>{date}</span>;
      },
    },
    !showSupplierProfileFile && {
      Header: "رقم العضوية",
      accessor: "membershipNumber",
      Cell: ({ row }) => row.original.membershipNumber || "-",
    },
    {
      Header: "الحالة",
      accessor: "status",
      Cell: ({ row }) => <StatusBadge status={row.original.status} />,
    },
    {
      Header: "التفاصيل",
      Cell: ({ row }) => <UserInfo user={row.original.user} />,
    },
    {
      Header: "الإجراء",
      Cell: ({ row }) => (
        <div className="flex items-start gap-2">
          <button
            className="rounded-full bg-green-500 px-6 py-1 text-white transition-all hover:bg-green-600 disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-400"
            onClick={() =>
              handleCommercialRegisterRequest(row.original.id, "accept").then(
                (res) => {
                  if (res.error) {
                    toast.error(res.error);
                  } else {
                    toast.success(res.success);
                    refetch();
                  }
                }
              )
            }
            disabled={row.original.status !== "pending"}
          >
            قبول
          </button>
          <button
            className="rounded-full bg-red-500 px-6 py-1 text-white transition-all hover:bg-red-600 disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-400"
            onClick={() =>
              handleCommercialRegisterRequest(row.original.id, "reject").then(
                (res) => {
                  if (res.error) {
                    toast.error(res.error);
                  } else {
                    toast.success(res.success);
                    refetch();
                  }
                }
              )
            }
            disabled={row.original.status !== "pending"}
          >
            رفض
          </button>
        </div>
      ),
    },
  ].filter(Boolean);
};

export default CommercialRegisterChangeRequestsColumn;
